<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Referansa Göre Hesap Ekstresi</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-layout row wrap>

              <v-flex pa-1 xs12 sm6 md6>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ currentDebtTotal }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ currentCreditTotal }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Cari Dönem </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>




              <v-flex pa-1 xs12 sm6 md6>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ debtTotal }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ creditTotal }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Genel Toplam </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>



            </v-layout>
          </v-container>


          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="500px">
            <v-card color="grey lighten-5">

              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>

                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>


                        <v-layout justify-space-between column>
                          <v-autocomplete clearable="" label="Cari Seçiniz" append-icon="search" autocomplete :loading="loading"
                            :items="statecari" item-text="text" cache-items="" item-value="id" v-model="EkstreHesap.Cari.Kod"
                            :search-input.sync="searchcari"></v-autocomplete>

                          <v-select hide-details="" :items="evraktipi" label="Evrak Cinsi" multiple="" v-model="secilenevraklar"
                            item-text="Aciklama" clearable item-value="Evrakkod" max-height="400"></v-select>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>

                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-card flat="" color="#9E9E9E">
                    <v-card-title>
                      <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                    </v-card-title>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-layout justify-space-between column>
                    <v-checkbox hide-details="" v-model="EkstreHesap.TlDoviz" label="TL+ Döviz"></v-checkbox>
                    <v-checkbox v-model="tumsirketler" label="Tüm Şirketler" hide-details=""></v-checkbox>
                  </v-layout>
                </v-flex>

              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Filtreleri Uygula</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-container fluid="">
            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>
                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>


                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>

                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-autocomplete clearable :items="Referans" label="Referans Seçiniz.." v-model="EkstreHesap.Referans.Kod"
                      item-text="ReferansAd" item-value="Kod" :rules="[v => !!v || 'Lütfen referans seçiniz']">
                    </v-autocomplete>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>

                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                        color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>

            <v-layout row="" wrap>
              <v-flex xs12 sm12>
                <v-card>
                  <v-card-title>
                    <v-spacer></v-spacer>

                  </v-card-title>
                  <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                    :search="search3">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">{{ props.item.Date }}</td>
                      <td class="text-xs-left">{{ props.item.RefCode }}</td>
                      <td class="text-xs-left">{{ props.item.DocumentType }}</td>
                      <td class="text-xs-left">{{ props.item.DocumentNumber}}</td>
                      <td class="text-xs-left">{{ props.item.Explanation}}</td>
                      <td class="text-xs-left">{{ props.item.DueDate }}</td>
                      <td class="text-xs-right">{{ props.item.Debt | moneyformat}}</td>
                      <td class="text-xs-right">{{ props.item.Credit | moneyformat }}</td>
                      <td class="text-xs-right">{{ props.item.Balance | bakiyekontrol }}</td>
                      <td class="text-xs-left">{{ props.item.BAType }}</td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>

                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                  :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                  {{ text }}
                  <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
              </v-flex>

            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'


  export default {
    data() {
      return {
        search: '',
        headers: [{
            text: 'Tarih',
            value: 'Date'
          },
          {
            text: 'Referans',
            value: 'RefCode'
          },
          {
            text: 'Evrak Tipi',
            value: 'DocumentType'
          },
          {
            text: 'Evrak No',
            value: 'DocumentNumber'
          },
          {
            text: 'Açıklama',
            value: 'Explanation'
          },
          {
            text: 'Vade Tarihi',
            value: 'DueDate'
          },
          {
            text: 'Borç',
            value: 'Debt',
            align: 'right'
          },
          {
            text: 'Alacak',
            value: 'Credit',
            align: 'right'
          },
          {
            text: 'Bakiye',
            value: 'Balance',
            align: 'right'
          },
          {
            text: 'B/A',
            value: 'BAType',
            align: 'right'
          }
        ],

        EkstreHesap: {
          Referans: {
            Kod: '',
          },
          BaslangicTarih: '',
          BitisTarih: '',
          Evraklar: [],
          Cari: {
            Kod: ''
          },
          SirketKodu: '',
          TlDoviz: false,
        },

        currentDebtTotal: 0,
        currentCreditTotal: 0,
        debtTotal: 0,
        creditTotal: 0,
        StartDate: null,
        EndDate: null,
        statecari: [],
        Referans: [],
        searchcari: '',
        valid: true,

        renk1: 'info',
        dialogfiltre: false,
        evraktipi: [],
        anahesap: [],
        tumsirketler: '',
        secilenevraklar: [{
          Evrakkod: ''
        }],


        dictionary: {
          custom: {
            referanskod: {
              required: () => 'Lütfen seçiminizi yapınız'
            },
            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },



        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        progress: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {

      this.el = this.$refs.fab.$el

    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,

      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      carigetir: carigetir
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }




    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false
    this.secilenevraklar = []
    this.tumsirketler = false
    this.EkstreHesap.TlDoviz = false
    this.EkstreHesap.Cari.Kod = null
  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function getList() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        this.progress = true
        this.currentDebtTotal = 0
        this.currentCreditTotal = 0
        this.debtTotal = 0
        this.creditTotal = 0

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.load = true
        this.load1 = false
        var Evraklar1 = []

        if (this.secilenevraklar.length > 0) {
          Object.keys(this.secilenevraklar).forEach(key => {
            var evrak = {
              Evrakkod: this.secilenevraklar[key]
            }
            Evraklar1.push(evrak)
          });

        }

        this.EkstreHesap.Evraklar = Evraklar1
        //this.EkstreHesap.Evraklar.Evrakkod = this.secilenevraklar


        if (this.tumsirketler === true) {
          this.EkstreHesap.SirketKodu = 0
        } else {
          this.EkstreHesap.SirketKodu = credentials.SirketKodu
        }

        this.EkstreHesap.BaslangicTarih = this.date
        this.EkstreHesap.BitisTarih = this.date2

        var params1 = this.EkstreHesap


        this.load1 = false

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithReference', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body[0].List


         // this.text = 'toplam ' + response.body[0].List.length + ' kayıt bulundu..'
         // this.snackbar = true
          this.currentCreditTotal = response.body[0].DonemAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
            '$1,')
          this.currentCreditTotal = response.body[0].DonemAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
            '$1,')

          this.currentDebtTotal = response.body[0].DonemBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
            '$1,')

          this.debtTotal = response.body[0].ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.creditTotal = response.body[0].ToplamAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }
  }


  function getListHtml() {

    this.$validator.validateAll().then((result) => {
      console.log('validator girdi')
      this.progress = true
      this.currentDebtTotal = 0
      this.currentCreditTotal = 0
      this.debtTotal = 0
      this.creditTotal = 0

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.load = true
      this.load1 = false
      var Evraklar1 = []

      if (this.secilenevraklar.length > 0) {
        Object.keys(this.secilenevraklar).forEach(key => {
          var evrak = {
            Evrakkod: this.secilenevraklar[key]
          }
          Evraklar1.push(evrak)
        });

      }

      this.EkstreHesap.Evraklar = Evraklar1

      if (this.date == null) {
        this.date = getDateNow()
      }

      if (this.date2 == null) {
        this.date2 = getDateNow()
      }


      if (this.tumsirketler === true) {
        this.EkstreHesap.SirketKodu = 0
      } else {
        this.EkstreHesap.SirketKodu = credentials.SirketKodu
      }

      this.EkstreHesap.BaslangicTarih = this.date
      this.EkstreHesap.BitisTarih = this.date2

      var params1 = this.EkstreHesap


      this.load1 = false

      this.$http
        .post(auth.API_URL + "api/Abstract/ListWithReferenceHtml", params1, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "ReferansEkstre.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    })
  }

  function getListExcel() {

    this.$validator.validateAll().then((result) => {
      console.log('validator girdi')
      this.progress = true
      this.currentDebtTotal = 0
      this.currentCreditTotal = 0
      this.debtTotal = 0
      this.creditTotal = 0

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.load = true
      this.load1 = false
      var Evraklar1 = []

      if (this.secilenevraklar.length > 0) {
        Object.keys(this.secilenevraklar).forEach(key => {
          var evrak = {
            Evrakkod: this.secilenevraklar[key]
          }
          Evraklar1.push(evrak)
        });

      }

      this.EkstreHesap.Evraklar = Evraklar1
      //this.EkstreHesap.Evraklar.Evrakkod = this.secilenevraklar

      if (this.date == null) {
        this.date = getDateNow()
      }

      if (this.date2 == null) {
        this.date2 = getDateNow()
      }


      if (this.tumsirketler === true) {
        this.EkstreHesap.SirketKodu = 0
      } else {
        this.EkstreHesap.SirketKodu = credentials.SirketKodu
      }

      this.EkstreHesap.BaslangicTarih = this.date
      this.EkstreHesap.BitisTarih = this.date2

      var params1 = this.EkstreHesap


      this.load1 = false

      this.$http
        .post(auth.API_URL + "api/Abstract/ListWithReferenceExcel", params1, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "ReferansEkstre.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    })
  }

  function beforeMount() {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Reference/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    this.$http.post(auth.API_URL + 'api/doctype/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })
    this.secilenevraklar = []
    this.EkstreHesap.Referans.Kod = null
  }
</script>
<style>
</style>